import { render, staticRenderFns } from "./InstructionsInfos.vue?vue&type=template&id=7538b7f7&scoped=true"
import script from "./InstructionsInfos.vue?vue&type=script&lang=js"
export * from "./InstructionsInfos.vue?vue&type=script&lang=js"
import style0 from "./InstructionsInfos.vue?vue&type=style&index=0&id=7538b7f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538b7f7",
  null
  
)

export default component.exports